import React from 'react';

const usd = (n) => (n == null ? '—' : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const F = ({ k, v, mono }) => (
  <div className="mb-1.5"><p className="text-[8px] uppercase tracking-wider text-gray-500">{k}</p>
    <p className={`text-[10px] text-gray-900 [overflow-wrap:anywhere] ${mono ? 'check-mono text-[8px]' : ''}`}>{v || '—'}</p></div>
);
const who = (p) => (p ? [...new Set([p.name, p.email, p.wallet].filter(Boolean))].join(' · ') : '');

export const RedemptionOrder = ({ c }) => {
  const o = c.redemption_order;
  return (
    <div className="mt-3 pt-2 border-t-2 border-gray-900" data-testid="tc-redemption-order">
      <p className="check-serif font-bold text-[11px] mb-2">PAYMENT / REDEMPTION ORDER {o ? `— ${o.order_no} (${o.version})` : '— for deposit and settlement'}</p>
      <div className="grid grid-cols-4 gap-3">
        <F k="Amount payable" v={`${usd(o?.amount_payable_usd ?? c.amount)} · dollar for dollar at face`} />
        <F k="Method" v={o ? (o.method === 'beth_wallet' ? 'Redeemed to BETH wallet (1 BETH = $1)' : 'Deposited with settlement agent') : 'Redeem to BETH wallet  ☐   Deposit with settlement agent  ☐'} />
        <F k="Pay to" v={o ? who(o.pay_to) : 'Settlement agent: ____________________'} />
        <F k="Presented by" v={o ? who(o.presented_by) : 'Holder: ____________________'} />
        <F k="Property / obligation" v={o?.property_or_obligation || (o ? '' : '____________________')} />
        <F k="Account / escrow ref." v={o?.account_reference || (o ? '' : '____________________')} />
        <F k="Closing date" v={o?.closing_date || (o ? '' : '__________')} />
        <F k="Order hash / settlement tx" v={o ? `${o.order_hash} · ${o.settlement_tx}` : 'Recorded on-chain when presented'} mono />
      </div>
      <p className="text-[7px] text-gray-600 mt-1">{c.redemption_statement}</p>
    </div>
  );
};

export const Form1099DA = ({ f }) => (
  <section className="check-panel check-stub" style={{ height: 'auto', minHeight: '3in' }} data-testid="tc-1099da-stub">
    <div className="flex justify-between items-baseline border-b-2 border-gray-900 pb-1 mb-2 irs-stub-head">
      <p className="check-serif font-bold text-[12px]">{f.title}</p>
      <p className="check-mono text-[10px]">Tax year {f.tax_year}</p>
    </div>
    <p className="text-[9px] text-gray-600 mb-2">Broker: {f.broker}</p>
    <table className="w-full text-[9px] border border-gray-300">
      <thead className="bg-[#e4efd9]"><tr>{['1a Digital asset', '1b Units', '1c Acquired', '1d Disposed', '1e Proceeds', '1f Cost basis', 'Gain/loss', 'Type', 'Recipient / TIN'].map(h => <th key={h} className="border border-gray-300 px-1 py-0.5 text-left">{h}</th>)}</tr></thead>
      <tbody>
        {f.rows.map((r, i) => (
          <tr key={i} data-testid={`tc-1099da-row-${i}`}>
            <td className="border border-gray-300 px-1">{r.box_1a}</td><td className="border border-gray-300 px-1">{r.box_1b_units}</td>
            <td className="border border-gray-300 px-1">{r.box_1c_date_acquired}</td><td className="border border-gray-300 px-1">{r.box_1d_date_disposed}</td>
            <td className="border border-gray-300 px-1">{usd(r.box_1e_proceeds_usd)}</td><td className="border border-gray-300 px-1">{usd(r.box_1f_cost_basis_usd)}</td>
            <td className="border border-gray-300 px-1">{usd(r.gain_loss_usd)}</td><td className="border border-gray-300 px-1">{r.disposition}</td>
            <td className="border border-gray-300 px-1">{r.recipient} · {r.recipient_tin}</td>
          </tr>
        ))}
        {!f.rows.length && <tr><td colSpan={9} className="border border-gray-300 px-1 py-2 text-center text-gray-500">No dispositions yet — rows are added when the check is sold, discounted, deposited or redeemed</td></tr>}
      </tbody>
    </table>
    <p className="text-[7px] text-gray-500 mt-1">{f.note}</p>
  </section>
);
